/*
  <metaobject-form> — submit handler for metaobject-driven forms (snippets/metaobject-form.liquid).

  Reads config from data attributes and posts to the HubSpot Forms Submission API:
    data-portal    HubSpot portal id
    data-guid      HubSpot form guid
    data-success   message shown after a successful submit
    data-sending / data-error / data-not-configured   translated status copy
*/
(function () {
  var HONEYPOT = 'company_website';

  // Collapse FormData into an ordered map of name -> [values]. Multi-value
  // controls (checkbox groups) keep every checked value; honeypot is dropped.
  function collect(form) {
    var map = {};
    var order = [];
    new FormData(form).forEach(function (value, name) {
      if (name === HONEYPOT) return;
      if (!map[name]) { map[name] = []; order.push(name); }
      map[name].push(value);
    });
    return { map: map, order: order };
  }

  // HubSpot Forms Submission API — portal id + form guid are public (they ship in the
  // embed snippet), so no secret is needed. Multi-values join with ';' per HubSpot spec.
  function buildRequest(el, data) {
    var fields = data.order.map(function (name) {
      return { name: name, value: data.map[name].join(';') };
    });
    return {
      url: 'https://api.hsforms.com/submissions/v3/integration/submit/' +
        encodeURIComponent(el.dataset.portal) + '/' + encodeURIComponent(el.dataset.guid),
      options: {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          fields: fields,
          context: { pageUri: window.location.href, pageName: document.title }
        })
      }
    };
  }

  if (!customElements.get('metaobject-form')) {
    customElements.define('metaobject-form', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.status = this.querySelector('[data-form-status]');
        this.button = this.querySelector('[type="submit"]');
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      setStatus(state, message) {
        if (!this.status) return;
        if (state) { this.status.setAttribute('data-state', state); }
        else { this.status.removeAttribute('data-state'); }
        this.status.textContent = message || '';
      }

      onSubmit(e) {
        e.preventDefault();

        // Honeypot — silently drop bot submissions
        var hp = this.form.querySelector('[name="' + HONEYPOT + '"]');
        if (hp && hp.value) return;

        if (!this.form.checkValidity()) { this.form.reportValidity(); return; }

        var req = buildRequest(this, collect(this.form));
        if (!this.dataset.portal || !this.dataset.guid) { this.setStatus('error', this.dataset.notConfigured || 'Form is not configured yet.'); return; }

        var label = this.button ? this.button.textContent : '';
        if (this.button) { this.button.disabled = true; this.button.textContent = this.dataset.sending || 'Sending…'; }
        this.setStatus(null, '');

        var self = this;
        fetch(req.url, req.options)
          .then(function (r) { if (!r.ok) throw new Error('bad status'); })
          .then(function () {
            self.form.reset();
            self.setStatus('success', self.dataset.success);
          })
          .catch(function () {
            self.setStatus('error', self.dataset.error || 'Something went wrong. Please try again.');
          })
          .finally(function () {
            if (self.button) { self.button.disabled = false; self.button.textContent = label; }
          });
      }
    });
  }
})();
